export enum RetainSizeModifier {
    EXTRA_SMALL = 'extra-small',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    EXTRA_LARGE = 'extra-large',
    TWO_XL = '2xl',
    FULL_WIDTH = 'full-width',
}
export enum RetainBehaviorModifier {
    NO_PADDING = 'no-padding',
    PADDING = 'padding',
    PADDING_INLINE_START = 'padding-inline-start',
    PADDING_INLINE_END = 'padding-inline-end',
    PADDING_INVERTED = 'padding-inverted',
    ONLY_BEHAVIOR_MODIFIERS = 'only-behavior-modifiers',
    ONLY_SET_CSS_CUSTOM_PROPERTIES = 'only-set-css-custom-properties',
    USE_EXISTING_CSS_CUSTOM_PROPERTIES = 'use-existing-css-custom-properties',
}
